import React from 'react'
import { Dropdown } from 'react-bootstrap'
import {
  PrimaryButton,
  DropdownPrimaryButtonMenu,
  DropdownPrimaryButtonMenuItem,
} from './DropdownPrimaryButton.styles'

export interface DropdownButtonItems {
  name: string
  onClick: (e: React.MouseEvent) => void
}

export interface DropdownButtonProps {
  label: string
  items: DropdownButtonItems[]
}

export const DropdownPrimaryButton = ({
  label,
  items,
}: DropdownButtonProps): JSX.Element => {
  return (
    <Dropdown>
      <Dropdown.Toggle as={PrimaryButton} id="dropdown-basic">
        {label ? label : 'Select Option'}
      </Dropdown.Toggle>

      <Dropdown.Menu as={DropdownPrimaryButtonMenu}>
        {items.map((item) => (
          <Dropdown.Item
            key={item.name}
            onClick={item.onClick}
            as={DropdownPrimaryButtonMenuItem}
          >
            {item.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
